<template>
  <div class="care-plus-dashboard-section-summary">
    <el-carousel direction="vertical" class="wp-100" height="40px">
      <el-carousel-item v-for="(event, index) in recentEvents" :key="index">
        <div
          style="display: flex; align-items: center; justify-content: space-between;"
        >
          <div>{{ currentEventText(event) }}</div>
          <img
            :src="require('@/assets/image/CarePlusDashboard/summary-icon2.png')"
            class="w-40 mr-5"
          />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    recentEvents: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentEventText() {
      return event => {
        let text = ''
        let type = event.Type

        switch (type) {
          case 'PAD_CHANGE':
            text = this.$t('text.pad_change_desc', {
              patientAlias: event.Alias,
              time: this.getTimeFormat(event.EventTime)
            })
            break
          case 'BATTERY_CHANGE':
            text = this.$t('text.battery_change_desc', {
              patientAlias: event.Alias,
              time: this.getTimeFormat(event.EventTime)
            })
            break
          case 'POSITION_CHANGE':
            text = this.$t('text.position_change_desc', {
              patientAlias: event.Alias,
              time: this.getTimeFormat(event.EventTime)
            })
            break
          case 'FALL_EVENT':
            text = this.$t('text.fall_event_desc', {
              patientAlias: event.Alias,
              time: this.getTimeFormat(event.EventTime)
            })
            break
          default:
            text = this.$t('text.pad_change_desc', {
              patientAlias: event.Alias,
              time: this.getTimeFormat(event.EventTime)
            })
        }
        return text
      }
    }
  },
  methods: {
    getTimeFormat(time) {
      let minutes = moment().diff(moment.utc(time), 'minutes')
      if (minutes >= 1440) {
        let day = Math.round(minutes / 1440)
        return `${day} ${this.$t('text.days_unit')}`
      } else if (minutes >= 60 && minutes < 1440) {
        let hour = Math.round(minutes / 60)
        return `${hour} ${this.$t('text.hours_unit')}`
      } else {
        return `${minutes} ${this.$t('text.minutes_unit')}`
      }
    }
  }
}
</script>
